import * as commonScripts from '../common'

const cmpAccordion = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element

	_.headers = document.querySelectorAll('.card-header');

	_.addClickEvents(_.headers);    
  },

  addClickEvents: function(headers)
  {
	for(let header of headers)
	{
		header.addEventListener('click', () => {
			header.classList.toggle('show');
		});
	}
  }
}

export default cmpAccordion
